import { render, staticRenderFns } from "./SchoolCodesDetails.vue?vue&type=template&id=2b60ad2e&"
import script from "./SchoolCodesDetails.vue?vue&type=script&lang=js&"
export * from "./SchoolCodesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports